export default function Footer() {
  return (
    <footer className="sl-footer text-center">
      <div className="container">
        StorageLoot &middot; {new Date().getFullYear()}
      </div>
    </footer>
  );
}
